const initialize = () => {
    $('.arrow-link').each(function() {
        if ($(this).find('.arrow-wrap').length > 0) return;
        $(this).append(`
            <span class="arrow-wrap">
                <span class="arrow-icon"></span>
            </span>
        `);
    });
};

export default {
    initialize,
};

